import React from "react"
import { motion } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { springVariants, leftVariants, springViewport } from '../utils/framerVariants'

const StickyTextInlineMedia = ({ data }) => {
  const { Headline, Text, Media, TextFold } = data;
  const isPortrait = data.portraitMode === true;

  // Define container and image classes
  let containerClass, imageClass;

  if (isPortrait) {
    imageClass = "aspect-DINA2 md:max-w-sm xl:max-w-sm";
    containerClass = "caption-rich-text md:max-w-sm xl:max-w-sm";
  } else {
    imageClass = "aspect-3/2";
    containerClass = "caption-rich-text md:max-w-sm xl:max-w-sm";
  }

  const renderCaption = () => {
    if (data.captionText?.trim()) {
      return <div className={containerClass} dangerouslySetInnerHTML={{ __html: data.captionText }} />;
    } else if (data.Media.caption) {
      return <p className="px-4 sm:px-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 max-w-xl">{data.Media.caption}</p>;
    }
    return null;
  };

  return (
    <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl pb-16 md:pb-24 lg:pb-32 xl:pb-48 mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-4 md:px-24 lg:px-24 xl:px-24">
      <div className="flex sm:flex-row flex-col">
        <div className="sm:basis-5/12 basis-full pr-0 lg:pr-12">
          <div className="sm:sticky sm:top-48 mb-8 md:mb-0">
            <motion.div
              variants={leftVariants}
              initial="invisible"
              whileInView="visible"
              viewport={springViewport}
              transition={{ delay: 0.2 }}
              className="absolute scharnier-form hidden xl:block 6xl:hidden 2xl-ml-[10%] 4xl:-ml-[20%]"
            >
              <div className="after:bg-black before:bg-black w-[1100px] h-[4px] after:translate-x-[3px] after:translate-y-[69px] after:w-[1100px] after:h-[4px] after:absolute after:content-[''] after:rotate-[-59deg] after:left-[-885px] after:top-[418px] before:translate-x-[-5px] before:translate-y-[-21px] before:w-[1100px] before:h-[4px] before:absolute before:content-[''] before:rotate-[25deg] before:left-[-1090px] before:top-[-196px]"
              ></div>
            </motion.div>
            {Headline && (
              <motion.h2
                variants={springVariants}
                initial="invisible"
                whileInView="visible"
                viewport={springViewport}
                className="text-headline-md tracking-headline-md leading-headline-md font-bold"
              >
                {Headline}
              </motion.h2>
            )}
          </div>
        </div>
        <div className="richtext sm:basis-7/12 basis-full pl-0 sm:pl-12 md:pl-16 lg:pl-32 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
          {Text && (
            <motion.div
              variants={springVariants}
              initial="invisible"
              whileInView="visible"
              viewport={springViewport}
              dangerouslySetInnerHTML={{ __html: Text }}
            />
          )}
          {Media && (
            <motion.div
              variants={springVariants}
              initial="invisible"
              whileInView="visible"
              viewport={springViewport}
            >
              <div className="mt-8 mb-5 lg:mt-16 lg:mb-12">
                <GatsbyImage
                  className={imageClass}
                  image={getImage(Media.file)}
                  alt={Media.alternativeText || "Alternative Text missing"}
                />
                {renderCaption()}
              </div>
            </motion.div>
          )}
          {TextFold && (
            <motion.div
              variants={springVariants}
              initial="invisible"
              whileInView="visible"
              viewport={springViewport}
              dangerouslySetInnerHTML={{ __html: TextFold }}
            />
          )}
        </div>
      </div>
    </article>
  );
}

export default StickyTextInlineMedia;
